import React, { useCallback, useState } from "react";
import "../../../css/components/NewsletterSubscription.css";
import "../../../css/components/ContactUs.css";
import OutlinedLightButton from "../../designSystem/OutlinedLightButton";
import "../../../css/pages/HomePage.css";
import { Recaptcha } from "../ContactUs";

const NewsletterSubscription = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [recaptchaKey, setRecaptchaKey] = useState(0);
  const [error, setError] = useState("");
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleRecaptchaChange = useCallback((token) => {
    setRecaptchaToken(token);
    setError("");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setError("Please confirm you are not a robot.");
      return;
    }

    try {
      // Send email notification to adviser
      const to = process.env.REACT_APP_ADVISER_EMAIL;
      const payload = {
        name: name.trim(),
        email: email.trim(),
        to: (to || "").trim(),
        number: "N/A",
        message: `You have received a new newsletter subscription request from your website.`,
        recaptchaToken,
      };
      const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errText = await res.text();
        console.log("API error:", errText);
        // alert("Failed to subscribe: " + errText);
        return;
      }
      // alert("Thank you for subscribing! We'll be in touch soon.");
      setEmail("");
      setName("");
      setRecaptchaToken("");
      setRecaptchaKey((key) => key + 1);
      setError("");
    } catch (err) {
      // alert("An error occurred. Please try again later.");
      console.log("NewsletterSubscription error:", err);
    }
  };

  return (
    <div className="burgandy-container">
      <div className="burgandy-container-content">
        <h2>WPP Financial Services Newsletter</h2>
        <div className="divider" />
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <div className="contact-field">
            <input
              type="email"
              placeholder="Email Address:"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="newsletter-input"
            />
          </div>
          <div className="contact-field">
            <input
              type="text"
              placeholder="Full Name:"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="newsletter-input"
            />
          </div>
          <div className="contact-recaptcha">
            {recaptchaSiteKey ? (
              <Recaptcha
                siteKey={recaptchaSiteKey}
                onChange={handleRecaptchaChange}
                resetKey={recaptchaKey}
              />
            ) : (
              <span className="error-text">
                reCAPTCHA is not configured. Add REACT_APP_RECAPTCHA_SITE_KEY.
              </span>
            )}
            {error ? <span className="error-text">{error}</span> : null}
          </div>
          <OutlinedLightButton
            text="Subscribe"
            type="submit"
            // className="newsletter-button"
          />
        </form>
      </div>
    </div>
  );
};

export default NewsletterSubscription;
